import { ApiRequestError } from '@app-types/api';
import type { HealthResponse, TokenRequest, TokenResponse } from '@app-types/auth';
import { authClient, toApiRequestError } from './client';

const normalizeTokenResponse = (response: TokenResponse): TokenResponse => {
  if (!response.token?.trim()) {
    throw new ApiRequestError('Authentication response is invalid.', {
      status: 500,
      body: { message: 'Authentication response is invalid.' },
    });
  }
  return response;
};

export const issueToken = async (request: TokenRequest): Promise<TokenResponse> => {
  try {
    const response = await authClient.post<TokenResponse>('/token', request);
    return normalizeTokenResponse(response.data);
  } catch (caught) {
    throw toApiRequestError(caught);
  }
};

export const checkAuthHealth = async (): Promise<HealthResponse> => {
  try {
    const response = await authClient.get<HealthResponse>('/health');
    return response.data;
  } catch (caught) {
    throw toApiRequestError(caught);
  }
};
